import { ChangeDetectionStrategy, Component, ViewEncapsulation, model, input } from '@angular/core';

@Component({
    selector: 'pulse-segmented-toggle',
    template: '<ng-content />',
    styleUrl: './pulse-segmented-toggle.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'pulse-segmented-toggle',
        role: 'group',
        '[attr.aria-label]': 'ariaLabel()',
    },
})
export class PulseSegmentedToggleComponent {
    /** Two-way bound selected value. Defaults to empty string. */
    readonly value = model<string>('');

    /** Accessible label for the group element. */
    readonly ariaLabel = input<string | undefined>(undefined);

    select(value: string): void {
        this.value.set(value);
    }
}
